import React, { useContext } from "react"
import Button from "../../../../components/Button"
import { Link } from "react-router-dom"
import AppContext from "../../../../shared/AppContext"
import "./style.scss"

export function ModelPreviewPanel(props) {
  const { name, title, subtitle, children, style, className = "" } = props

  let combinedTitleTest = ""
  let previewTitle = ""
  let previewSubtitle = ""

  if (title && subtitle) {
    combinedTitleTest = `${title
      .trim()
      .toLowerCase()} - ${subtitle.trim().toLowerCase()}`
  }

  switch (combinedTitleTest) {
    case "shared accounts - time series":
      previewTitle = "Shared Account Time Series"
      previewSubtitle = (
        <span>
          See how <strong>{name}</strong> customers are simultaneously spending
          with peers/competitors (versus three months ago and one year-ago
          levels)
        </span>
      )
      break
    case "time series - single vendor aggregate":
      previewTitle = `${name} - Single Vendor Aggregate`
      previewSubtitle = (
        <span>
          The historical response breakdown for <strong>{name}</strong>; the
          blue line represents Net score while the yellow line represents Market
          share.
        </span>
      )
      break
    case "vendor spend focus - respondent subsample":
      previewTitle = `${name} Spend Focus - Respondent Subsample`
      previewSubtitle = (
        <span>
          Spending Intentions for <strong>{name}</strong> by customer type
          (Index, Region, Vertical, etc.)
        </span>
      )
      break
    case "vendor spend focus - single vendor view":
      previewTitle = `${name} Spend Focus`
      previewSubtitle = (
        <span>
          Spending Intentions for <strong>{name}</strong> across all Sectors
          that track it
        </span>
      )
      break
    default:
      previewTitle = title
      previewSubtitle = subtitle
      break
  }

  return (
    <section className={`model-preview ${className}`} style={style}>
      <h2 className="model-preview-title">{previewTitle}</h2>
      <h3 className="model-preview-subtitle">{previewSubtitle}</h3>
      {children}
    </section>
  )
}

export function ModelPreviewImage(props) {
  const {
    link,
    isAuthenticated,
    hasNoAccess,
    imageURL,
    style,
    className = "",
    onCtaClick = () => {},
    trackingLocation,
    alt,
  } = props

  const { trackEvent } = useContext(AppContext)

  const image = (
    <figure className={`model-preview-image ${className}`} style={style}>
      <img src={imageURL} width="100%" alt={alt} />
    </figure>
  )

  if (!isAuthenticated || hasNoAccess) {
    return (
      <div
        className="model-preview-image-wrap"
        data-get-access="true"
        data-cy="vendor-image"
      >
        {image}
        <Button
          classes={["model-preview-image-button", "btn-primary"]}
          action={onCtaClick}
        >
          Get Access
        </Button>
      </div>
    )
  }

  return (
    <div className="model-preview-image-wrap" data-cy="vendor-image">
      <Link
        to={link}
        target="_blank"
        onClick={() =>
          trackEvent("Model Image Clicked", {
            location: trackingLocation,
            to: link,
          })
        }
      >
        {image}
      </Link>
    </div>
  )
}
